module.exports = __webpack_public_path__ + "img/5.3ef2766f.webp";